'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgAdd } from '@common/icon';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { CustomLink } from '@/app/_components/CustomLink';
import { ServiceSwitchDropdown } from '@/app/_components/ServiceSwitchDropdown';
import { DONATION_BNB_TOAST_ITEMS } from '@/app/donation/constants';
import { DONATION_ROUTES, ROUTES, SUB_DOMAIN } from '@/constants';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { gtmDatasets } from '@/utils/analytics/gtm';
const ANIMATION_DURATION = 300;
interface DonationBnbProps {
  className?: string;
  isMounted?: boolean;
}
export const DonationBnb = t0 => {
  const $ = _c(21);
  const {
    className,
    isMounted: t1
  } = t0;
  const isMounted = t1 === undefined ? true : t1;
  const pathname = usePathname();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [menuClickAnimated, setMenuClickAnimated] = useState(t2);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobile, isToss] = useDeviceInfoStore(useShallow(_temp));
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = index => {
      setMenuClickAnimated(prev => ({
        ...prev,
        [index]: true
      }));
      setTimeout(() => {
        setMenuClickAnimated(prev_0 => ({
          ...prev_0,
          [index]: false
        }));
      }, ANIMATION_DURATION);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleMenuClick = t3;
  let t4;
  if ($[2] !== className) {
    t4 = cn("relative mx-20 flex items-center rounded-pill bg-Gray-white p-8 shadow-[0px_0px_30px_0px_rgba(0,0,0,0.05),0px_16px_50px_0px_rgba(0,0,0,0.05)]", className);
    $[2] = className;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isDropdownOpen || $[5] !== isToss) {
    t5 = !isToss ? <div className="relative z-50"><button type="button" className="relative z-50 size-40 rounded-pill bg-Gray-200 flex-center" onClick={() => setIsDropdownOpen(_temp2)} aria-label={"\uB2E4\uB978 \uC11C\uBE44\uC2A4\uB85C \uC774\uB3D9"} aria-expanded={isDropdownOpen}><SvgAdd className={cn("size-20 text-Gray-600 transition-transform duration-200", {
          "rotate-45": isDropdownOpen
        })} /></button><ServiceSwitchDropdown isOpen={isDropdownOpen} onClose={() => setIsDropdownOpen(false)} currentService="donation" /></div> : null;
    $[4] = isDropdownOpen;
    $[5] = isToss;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = isMobile ? "space-between" : "space-around";
  const t7 = isMobile ? "" : "0 30px";
  let t8;
  if ($[7] !== t6 || $[8] !== t7) {
    t8 = {
      justifyContent: t6,
      padding: t7
    };
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== isMounted || $[11] !== menuClickAnimated || $[12] !== pathname) {
    t9 = DONATION_BNB_TOAST_ITEMS.map((t10, index_0) => {
      const {
        label,
        route,
        icon: Icon
      } = t10;
      const isActive = (() => {
        if (!pathname) {
          return false;
        }
        if (route.pathname === DONATION_ROUTES.HOME.pathname) {
          return pathname === route.pathname;
        }
        if (route.pathname === DONATION_ROUTES.MY.pathname) {
          return pathname === ROUTES.MY.pathname || pathname.includes(route.pathname);
        }
        return pathname.includes(route.pathname);
      })();
      const clickFnbDataset = gtmDatasets.clickFnb({
        menu_name: label
      });
      return <li key={label} className="w-53"><CustomLink href={route.pathname} aria-label={`${label} 페이지로 이동`} prefetch={true} className={cn("flex w-full flex-col items-center duration-150", menuClickAnimated[index_0] && "animate-jump", isMounted ? "scale-100" : "scale-0")} style={{
          animationDuration: `${ANIMATION_DURATION}ms`,
          transitionDelay: `${(index_0 + 1) * 60}ms`,
          transitionProperty: "transform",
          transitionDuration: "300ms"
        }} onClick={() => handleMenuClick(index_0)} {...clickFnbDataset}><Icon className={cn("size-28 text-Gray-400", {
            "text-Gray-black": isActive
          })} /><p className={cn("whitespace-nowrap text-center font-500 text-Gray-550 typo-caption2", {
            "font-600 text-Gray-900": isActive
          })}>{label}</p></CustomLink></li>;
    });
    $[10] = isMounted;
    $[11] = menuClickAnimated;
    $[12] = pathname;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <ul className="flex flex-1 items-center" style={t8}>{t9}</ul>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t4 || $[19] !== t5) {
    t11 = <nav aria-label={"\uAE30\uBD80 \uB0B4\uBE44\uAC8C\uC774\uC158"} className={t4}>{t5}{t10}</nav>;
    $[17] = t10;
    $[18] = t4;
    $[19] = t5;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};
function _temp(state) {
  return [["android", "ios"].includes(state.osType || "unknown"), state.subDomain === SUB_DOMAIN.TOSS] as const;
}
function _temp2(prev_1) {
  return !prev_1;
}